import React from 'react';

export const Part0DataSource = {
  wrapper: { className: 'part0 part-page-wrapper'},
  textWrapper: { className:'part0-text-wrapper'},
  content:{
    className:'part0-content',
    children: (
      <div>
        <h3>CAN HEALTHY系列</h3>
        <h1>AI重塑SPD效率</h1>
      </div>
    ),
  },
}

export const Part1DataSource = {
  wrapper: { className: 'home-page-wrapper healthy-part1' },
  page: { className: 'home-page healthy-part1-page' },
  childWrapper: {
    className: 'healthy-part1-title-wrapper',
    children: [
      { name: 'title', children: 'CanHealthy ', className: 'healthy-part1-title color-0' },
      { name:'title',children:' AI Vision-Based UDI Traceability System for Medical Consumables', className:'healthy-part1-title-sub-canhealthy color-0' },
      {
        name: 'content',
        className: 'healthy-part1-content',
        children: '基于视觉AI的医用耗材UDI码追溯系列',
      },
      {
        name: 'a',
        className:'healthy-part1-a color-0',
        href: '/uditrace',
        children: '进一步了解 >',//{ href: '#', className:'banner4-a', children: '进一步了解 >' },
      },
    ],
  },
  image: {
    className: 'healthy-part1-image',
    children:
      process.env.SOURCE_URL+'/udi-main.png',
  },
};

export const Part2DataSource = {
  wrapper: { className: 'home-page-wrapper healthy-part2-wrapper' },
  page: { className: 'home-page healthy-part2' },
  OverPack: { playScale: 0.3, className: '' },
  childWrapper: {
      className: 'healthy-part2-text-wrapper',
      children: [
          {
              name: 'title',
              children: 'CanHealthy',
              className: 'healthy-part2-title',
          },
          {
              name: 'content',
              className: 'healthy-part2-content',
              children: 'AI Vision-Based Orthopedic Internal Fixation Instrument Counting Series',
          },
          {
              name: 'intro',
              className: 'healthy-part2-intro',
              children: '基于视觉AI的骨科内固定器械清点系列',
          },
          {
            name:'a',
            className:'healthy-part2-a',
            href:'/nailtool',
            children:'进一步了解 >'
          }
      ],
  },
  image: {
      className: 'healthy-part2-image',
      children:
          process.env.SOURCE_URL+'/canhealthy-nail.png',
  },

};

export const Part3DataSource = {
  wrapper: { className: 'home-page-wrapper healthy-part3-wrapper' },
  page: { className: 'home-page healthy-part3' },
  OverPack: { playScale: 0.3, className: '' },
  childWrapper: {
      className: 'healthy-part3-text-wrapper',
      children: [
          {
              name: 'title',
              children: 'CanHealthy',
              className: 'healthy-part3-title',
          },
          {
              name: 'content',
              className: 'healthy-part3-content',
              children: 'AI Vision-Based Surgical Inventory System',
          },
          {
              name: 'intro',
              className: 'healthy-part3-intro',
              children: '基于视觉AI的手术工具清点系列',
          },
          {
            name:'a',
            className:'healthy-part3-a',
            href:'/surgicaltool',
            children:'进一步了解 >'
          }
      ],
  },
  image: {
      className: 'healthy-part3-image',
      children:
          process.env.SOURCE_URL+'/canhealthy-part3-main.png',
  },

};


export const Part4DataSource = {
  wrapper: { className: 'part4 part4-page-wrapper'},
  textWrapper: { className:'part4-text-wrapper'},
  content:{
    className:'part4-content',
    children: (
      <div>
        <h1>联系我们</h1>
        <h3>获得医疗器械供应链核心服务</h3>
      </div>
    ),
  },
}

